import React, { forwardRef } from "react";
import { isUndefined } from "lodash";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Dropdown from "@client.components/Dropdown";
import UserRoles from "@client.enums/userRoles";

const DropdownUserRoles = forwardRef(
  (
    {
      onSelect,
      placeholder,
      defaultValue,
      items,
      showDescription,
      id,
      error,
      disabled,
    },
    ref
  ) => {
    const { t } = useTranslation();

    const roles = [
      {
        label: t("components.DropdownUserRoles.allRoles"),
        value: UserRoles.All,
      },
      {
        label: UserRoles.SuperAdmin,
        value: UserRoles.SuperAdmin,
        description: t("components.DropdownUserRoles.SuperAdmin.description"),
      },
      {
        label: UserRoles.CXO,
        value: UserRoles.CXO,
        description: t("components.DropdownUserRoles.CXO.description"),
      },
      {
        label: UserRoles.Executive,
        value: UserRoles.Executive,
        description: t("components.DropdownUserRoles.Executive.description"),
      },
      {
        label: UserRoles.Manager,
        value: UserRoles.Manager,
        description: t("components.DropdownUserRoles.Manager.description"),
      },
      {
        label: UserRoles.Viewer,
        value: UserRoles.Viewer,
        description: t("components.DropdownUserRoles.Viewer.description"),
      },
    ];

    let dataSource = roles;
    if (items) {
      dataSource = roles.filter((r) => items.indexOf(r.value) > -1);

      if (
        !isUndefined(defaultValue) &&
        !dataSource.find((r) => r.value === defaultValue)
      ) {
        // only for a case when user tries to update himself.
        const missingItem = roles.find((r) => r.value === defaultValue);

        dataSource.push(missingItem);
      }
    }

    const getItem = (v) => roles.find((r) => r.value == v);

    React.useImperativeHandle(ref, () => ({
      getItem: getItem,
    }));

    return (
      <Dropdown
        id={id}
        disabled={disabled}
        error={error}
        items={dataSource}
        valueKey="value"
        labelKey="label"
        descriptionKey={showDescription ? "description" : null}
        placeholder={placeholder}
        defaultValue={defaultValue}
        onSelect={(val, item) => {
          onSelect(val === UserRoles.All ? null : val, item);
        }}
      />
    );
  }
);

DropdownUserRoles.displayName = "DropdownUserRoles";

DropdownUserRoles.defaultValue = {
  items: null,
  showDescription: false,
  disabled: false,
};

DropdownUserRoles.propTypes = {
  error: PropTypes.array,
  id: PropTypes.string,
  onSelect: PropTypes.func,
  items: PropTypes.array,
  defaultValue: PropTypes.any,
  placeholder: PropTypes.string,
  showDescription: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default DropdownUserRoles;
